<template>

	<div>
		<v-stepper v-model="e6" vertical style="border:0;box-shadow:none;">
			<v-stepper-step

					step="1"
			>
				In your browser, while connected to the router's network, navigate to your router admin console
			</v-stepper-step>

			<v-stepper-content step="10">
				Usually: http://192.168.1.1

			</v-stepper-content>


			<v-stepper-step step="2"
			>
				Sign in to the router's console.
			</v-stepper-step>

			<v-stepper-content step="10">
				The default credentials are

				username: admin
				password: admin

			</v-stepper-content>



			<v-stepper-step step="3" >
				In the left menu, under "Advanced settings" click on LAN
			</v-stepper-step>

			<v-stepper-content step="10">

			</v-stepper-content>

			<v-stepper-step step="4" >
				At the top part, click on the "Route" tab.
			</v-stepper-step>

			<v-stepper-content step="10">



			</v-stepper-content>

			<v-stepper-step step="5" >
				Locate "Enable static routes" row, and check "Yes"
			</v-stepper-step>

			<v-stepper-content step="10">

			</v-stepper-content>

			<v-stepper-step step="6" >
				Under "Static Route list" enter the following, when done, click the "+" icon
			</v-stepper-step>

			<v-stepper-content step="10">
				Network/Host IP: 8.8.8.8<br>
				Netmask: 255.255.255.255<br>
				Gateway: Your router default IP, Usually: 192.168.1.1<br>
				Metric: 2<br>
				Interface: LAN
			</v-stepper-content>

			<v-stepper-step step="7" >
				Under "Static Route list" enter the following, when done, click the "+" icon
			</v-stepper-step>

			<v-stepper-content step="10">
				Network/Host IP: 8.8.4.4<br>
				Netmask: 255.255.255.255<br>
				Gateway: Your router default IP, Usually: 192.168.1.1<br>
				Metric: 2<br>
				Interface: LAN
			</v-stepper-content>

			<v-stepper-step step="8" >
				 Click "Apply"
			</v-stepper-step>

			<v-stepper-content step="10">

			</v-stepper-content>

		</v-stepper>


	</div>


</template>

<style scoped>

	>>> .v-stepper__label {
		color: rgba(0, 0, 0, 0.87)!important;
	}

</style>

<script>



  // import i18n from '@/i18n';
  // import Page from '../mixins/page'


  export default {
    title: "Block IP address on ASUS",
    name: 'block-ip-address/huawei',
	  data: ()=>({
		  e6:10
	  }),
	  components: {



	  }
  };
</script>
